/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( '.practice-search__form' ).on( 'submit', function( e ) {
        e.preventDefault();

        const firstName = $( this ).find( 'input[name="coach_first_name"]' ).val();
        const lastName = $( this ).find( 'input[name="coach_last_name"]' ).val();
        const firstNameLower = firstName.toLowerCase();
        const lastNameLower = lastName.toLowerCase();
        $( '.practice-search__coaches li' ).hide();
        $( '.practice-search__coaches' ).show();

        let shownCoaches = 0;
        $( '.practice-search__coaches li' ).each( function( key, val ) {
          const valFirstLower = $( val ).attr( 'data-first' ).toLowerCase();
          const valLastLower = $( val ).attr( 'data-last' ).toLowerCase();
          if ( valFirstLower == firstNameLower && valLastLower == lastNameLower ) {
            $( val ).show();
            shownCoaches++;
          }
        } );

        if ( shownCoaches == 0 ) {
          $( '.no-results' ).show();
          $( '.has-results' ).hide();
        } else {
          $( '.no-results' ).hide();
          $( '.has-results' ).show();
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'practice-search', COMPONENT );
} )( app );
